import { RootState } from '@/store/root-state';
import { createSelector } from '@reduxjs/toolkit';

const selectCampaignsState = (state: RootState) => state.campaigns;

export const selectCampaigns = createSelector(selectCampaignsState, (state) => state.campaigns);
export const selectLoadingCampaigns = createSelector(selectCampaignsState, (state) => state.loadingCampaigns);
export const selectErrorLoadingCampaigns = createSelector(selectCampaignsState, (state) => state.errorLoadingCampaigns);
export const selectCreatingCampaign = createSelector(selectCampaignsState, (state) => state.creatingCampaign);
export const selectErrorCreatingCampaign = createSelector(selectCampaignsState, (state) => state.errorCreatingCampaign);
export const selectLastCreatedCampaign = createSelector(selectCampaignsState, (state) => state.lastCreatedCampaign);
export const selectCampaignByUuid = (uuid: string | undefined) =>
  createSelector(selectCampaigns, (campaigns) => campaigns.find((c) => c.uuid === uuid));
export const selectDeletingCampaignUuid = createSelector(selectCampaignsState, (state) => state.deletingCampaignUuid);
export const selectErrorDeletingCampaign = createSelector(selectCampaignsState, (state) => state.errorDeletingCampaign);
export const selectFavoriteTemplates = createSelector(selectCampaignsState, (state) => state.favoriteTemplates);
export const selectRecentTemplates = createSelector(selectCampaignsState, (state) => state.recentTemplates);
